import { createContext, useContext, ReactNode, useState } from "react";

interface ErrorsContextType {
  errors: string[];
  addError: (error: string) => void;
  clearErrors: () => void;
}

const ErrorsContext = createContext<ErrorsContextType | undefined>(undefined);

export const ErrorsProvider = ({ children }: { children: ReactNode }) => {
  const [errors, setErrors] = useState<string[]>([]);

  const addError = (error: string) => {
    setErrors((prev) => [...prev, error]);
  };

  const clearErrors = () => {
    setErrors([]);
  };

  return (
    <ErrorsContext.Provider value={{ errors, addError, clearErrors }}>
      {children}
    </ErrorsContext.Provider>
  );
};

export const useErrors = () => {
  const context = useContext(ErrorsContext);
  if (!context) {
    throw new Error("useErrors must be used within ErrorsProvider");
  }
  return context;
};
